import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";

import { MDSButton, MDSButtonSize, MDSButtonVariant } from "@/mds";
import { useAppStore } from "@/store";

export const TopBarProactiveUpgradeButton = observer(function TopBarProactiveUpgradeButton() {
  const { store } = useAppStore();

  if (store.subscriptions.hasProactiveAccess) {
    return null;
  }

  return (
    <StyledUpgradeButton
      aria-label="Upgrade to Mem Proactive"
      size={MDSButtonSize.Small}
      variant={MDSButtonVariant.EmphasisLight}
      onPress={() => store.subscriptions.openProactiveUpsell()}
    >
      Upgrade
    </StyledUpgradeButton>
  );
});

const StyledUpgradeButton = styled(MDSButton)`
  box-sizing: border-box;
  height: 100%;
  flex: 0 0 auto;
  min-width: 80px;
  border-radius: ${({ theme }) => theme.borderRadius.max};
  -webkit-app-region: no-drag;
`;
